import React, { useState, useCallback } from 'react';

import { Button, Space, Form, Checkbox } from 'antd';
import MerchantMenuSelector from 'menuManagement/MerchantMenuSelector';
import propTypes from 'prop-types';

import { convertMenuImages } from 'menuManagement/MenuManagementHelpers';

import ResponseModal from './ResponseModal';

const { Item } = Form;

ConvertImages.propTypes = {
	merchantId: propTypes.string.isRequired,
};

export default function ConvertImages({ merchantId }) {
	const [responseModalVisible, setResponseModalVisible] = useState(false);
	const [response, setResponse] = useState({});
	const [menuSelectValue, setMenuSelectValue] = useState('');
	const [forceAllURLs, setForceAllURLs] = useState(false);

	const onFinish = useCallback(async () => {
		try {
			setResponseModalVisible(true);
			setResponse({ loading: true });
			const menuManagementResponse = await convertMenuImages(
				menuSelectValue,
				forceAllURLs,
			);
			setResponse(menuManagementResponse);
		} catch (e) {
			setResponseModalVisible(true);
			console.error(`Exception while accessing Menu Management - ${e}`);
			setResponse({ error: 'Exception while accessing Menu Management' });
		}
	}, [menuSelectValue, forceAllURLs]);

	const onFinishFailed = useCallback(() => {
		console.error('Invalid UUID');
	}, []);

	return (
		<Form
			name="convertImages"
			labelCol={{ span: 24 }}
			wrapperCol={{ span: 18 }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete="off"
			style={{ width: 600 }}
		>
			<Space direction="vertical" size="small">
				<div>
					This tool will convert externally hosted images to a webp format
					cropped to a 4:3 aspect ratio.
					<br />
					<br />
					<strong>Note:</strong> By using the &quot;Force Convert All
					Images&quot; option, you will convert all images in the menu to webp
					format with the 4:3 aspect ratio, regardless of whether they are
					hosted on external URLs or not.
					<br />
					<br />
				</div>
				<Item
					label="Target Menu for Image Conversion:"
					name="menuUuid"
					rules={[
						() => ({
							validator() {
								if (!menuSelectValue.length) {
									return Promise.reject(new Error('Select a menu.'));
								}
								return Promise.resolve();
							},
						}),
					]}
				>
					<MerchantMenuSelector
						setMenuSelectValue={setMenuSelectValue}
						merchantId={merchantId}
						selectType="single"
					/>
				</Item>
				<Item name="forceAllURLs">
					<Space>
						Force Convert All Images:
						<Checkbox
							onChange={() => setForceAllURLs(!forceAllURLs)}
							checked={forceAllURLs}
						/>
					</Space>
				</Item>
				<Button type="primary" htmlType="submit" disabled={!menuSelectValue}>
					Convert Images
				</Button>
				<ResponseModal
					title="Image Conversion Result"
					response={response}
					responseModalVisible={responseModalVisible}
					setResponseModalVisible={setResponseModalVisible}
				/>
			</Space>
		</Form>
	);
}
